export const enum ActivationState {
  SIGNUP = 'green',
  EXISTING_USER = 'yellow',
  LOCG_SIGNUP = 'green_locg'
}
